import {useTranslation} from 'react-i18next'
import type {CreativePlacementSpec} from '../../../common/constants/creativeAssetSpecs'
import {safeAreaStyle} from './safeAreaStyle'

interface SafeAreaOverlayProps {
  spec: CreativePlacementSpec
}

/** Dashed outline of the safe area, positioned in % so it tracks the canvas at any display size. */
const SafeAreaOverlay = ({spec}: SafeAreaOverlayProps) => {
  const {t} = useTranslation()
  return (
    <div className="caa-safe-area" style={safeAreaStyle(spec)} aria-hidden>
      <span className="caa-safe-area-tag">{t('creativeAssets.canvas.safeArea')}</span>
    </div>
  )
}

export default SafeAreaOverlay
